import ComponentElement from 'components/component-element';
import PhotogalleryModal from './photogallery-modal';

/**
 * Галерея фото
 * @param {Element} $element Блок с фотографиями
 * @param {Object}  options  Параметры
 */
function Photogallery($element, options = {}) {
    ComponentElement.call(this, $element, options);

    // парсинг данных фотогалереи
    try {
        this.data = JSON.parse(this.$element.querySelector('.js-photogalleryData').innerHTML);
    } catch (e) {
        this.data = {};
    }

    this.$element.querySelectorAll('.js-photogalleryImage').forEach(($el, index) => {
        $el.addEventListener('click', e => {
            if (!this.modal) {
                this.modal = new PhotogalleryModal(this, {
                    on: {
                        close: () => {
                            this.modal.$element.remove();
                        },
                    },
                });
            }

            this.modal.open();
            this.modal.navigate(index);
        });
    });
}

// цепочка прототипов
Photogallery.prototype = Object.create(ComponentElement.prototype, {
    constructor: {
        value: Photogallery,
        writable: true,
        enumerable: false,
    },
});

export default Photogallery;
